import * as React from "react";
import { IconProps } from "../types";

const CoinsOutlineIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M9.5 5.75C12.9518 5.75 15.75 4.85457 15.75 3.75C15.75 2.64543 12.9518 1.75 9.5 1.75C6.04822 1.75 3.25 2.64543 3.25 3.75C3.25 4.85457 6.04822 5.75 9.5 5.75Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.25 3.75V6.75C3.25 7.854 6.048 8.75 9.5 8.75C12.952 8.75 15.75 7.854 15.75 6.75V3.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.5 5.75V8.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.25 5.45801V8.45801"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.75 5.45801V8.45801"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.25 11.25V14.25C2.25 15.354 5.048 16.25 8.5 16.25C11.952 16.25 14.75 15.354 14.75 14.25V11.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.5 13.25V16.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.25 12.958V15.958"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.75 12.958V15.958"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.311 10.135C2.641 10.454 2.25 10.837 2.25 11.25C2.25 12.354 5.048 13.25 8.5 13.25C11.952 13.25 14.75 12.354 14.75 11.25C14.75 11.027 14.631 10.812 14.42 10.612"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default CoinsOutlineIcon;
